import { TBlockType } from '../types';

export function isUnstyled(blockType: TBlockType) {
  return ['unstyled', 'ordered-list-item', 'unordered-list-item'].includes(blockType);
}
